import type { MouseEventHandler } from 'react';
import { Send } from '@mui/icons-material';
import { Button, ThemeProvider, createTheme } from '@mui/material';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

type Props = {
  onClick: MouseEventHandler<HTMLElement>;
};

export const MessageSendButton = (props: Props) => {
  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            background: 'var(--c-button-background)',
            borderRadius: 20,
            padding: '8px 16px',
            width: '108px',
            height: '36px',
          },
        },
      },
    },
  });
  const { t: tAuditionInfo } = useTranslationWithLang('auditionInfo');

  return (
    <ThemeProvider theme={theme}>
      <Button
        aria-label="send-button"
        variant="contained"
        disableElevation
        onClick={props.onClick}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = 'var(--c-button-background-hover)')
        }
        onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--c-button-background)')}
        title={tAuditionInfo('TU005_022')}
      >
        <Send></Send>
      </Button>
    </ThemeProvider>
  );
};
